import React, { Component, Fragment } from 'react';

class InputFeedback extends Component {
  render() {
    const { error } = this.props;

    return (
      <Fragment>
        {error ? <div className="input-feedback">{error}</div> : null}
      </Fragment>
    );
  }
}

export default InputFeedback;



// WEBPACK FOOTER //
// ./src/components/InputFeedback/InputFeedback.js